import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mall-my-filter" }
const _hoisted_2 = {
  class: "mall-my-filter__presets",
  role: "group",
  "aria-label": "기간 빠른 선택"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "mall-my-filter__row" }
const _hoisted_5 = { class: "mall-my-filter__date" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "mall-my-filter__date" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "mall-my-filter__search"
}
const _hoisted_10 = ["value", "placeholder"]
const _hoisted_11 = { class: "mall-my-filter__actions" }

import { DATE_PRESETS, type DatePresetKey } from '@/utils/dateInput'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallMyFilterBar',
  props: {
    fromDate: {},
    toDate: {},
    keyword: { default: '' },
    preset: {},
    placeholder: { default: '검색어' },
    searchable: { type: Boolean, default: true }
  },
  emits: ["update:fromDate", "update:toDate", "update:keyword", "preset", "search"],
  setup(__props: any) {





const presets = DATE_PRESETS

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(presets), (item) => {
        return (_openBlock(), _createElementBlock("button", {
          key: item.key,
          type: "button",
          class: _normalizeClass({ 'is-active': __props.preset === item.key }),
          onClick: ($event: any) => (_ctx.$emit('preset', item.key))
        }, _toDisplayString(item.label), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, [
        _cache[5] || (_cache[5] = _createElementVNode("span", null, "시작일", -1)),
        _createElementVNode("input", {
          value: __props.fromDate,
          type: "date",
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:fromDate', ($event.target as HTMLInputElement).value)))
        }, null, 40, _hoisted_6)
      ]),
      _createElementVNode("label", _hoisted_7, [
        _cache[6] || (_cache[6] = _createElementVNode("span", null, "종료일", -1)),
        _createElementVNode("input", {
          value: __props.toDate,
          type: "date",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:toDate', ($event.target as HTMLInputElement).value)))
        }, null, 40, _hoisted_8)
      ]),
      (__props.searchable)
        ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "검색", -1)),
            _createElementVNode("input", {
              value: __props.keyword,
              type: "search",
              placeholder: __props.placeholder,
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:keyword', ($event.target as HTMLInputElement).value))),
              onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('search')), ["prevent"]), ["enter"]))
            }, null, 40, _hoisted_10)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          class: "mall-my-filter__btn",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('search')))
        }, "조회")
      ])
    ])
  ]))
}
}

})